// extracted by mini-css-extract-plugin
export default {"header":"Header_header__TuEYM","nav-link":"Header_nav-link__P7sYl","logo-wrapper":"Header_logo-wrapper__SXxa7"};